import * as React from 'react';

export default () => (
  <svg
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <g
      id="Soliplus-Mobile"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g id="3.1-inicio-copy-4" transform="translate(-217.000000, -193.000000)">
        <g id="Group-7" transform="translate(217.000000, 193.000000)">
          <circle id="Oval" fill="#0088FF" cx="10.5" cy="10.5" r="10.5" />
          <path
            d="M11.038,9.344 L11.304,9.428 C11.96667,9.63333436 12.500998,9.8293324 12.907,10.016 C13.313002,10.2026676 13.6583319,10.4849981 13.943,10.863 C14.2276681,11.2410019 14.37,11.7426635 14.37,12.368 C14.37,12.8533358 14.2463346,13.3036646 13.999,13.719 C13.7516654,14.1343354 13.3806691,14.4679987 12.886,14.72 C12.4531645,14.9405011 11.9345855,15.0645315 11.3302509,15.0920938 L11.038,15.098 L11.038,16.218 L10.562,16.218 L10.562,15.07 C9.63799538,14.995333 8.88200294,14.7036692 8.294,14.195 C7.70599706,13.6863308 7.37933366,13.0400039 7.314,12.256 L9.022,12.256 C9.05933352,12.6200018 9.21099867,12.9513318 9.477,13.25 C9.74300133,13.5486682 10.1046644,13.735333 10.562,13.81 L10.562,10.632 L10.0221237,10.4626871 C9.5163736,10.2990622 9.11300151,10.1525006 8.812,10.023 C8.41066466,9.85033247 8.05600154,9.57266858 7.748,9.19 C7.43999846,8.80733142 7.286,8.29400322 7.286,7.65 C7.286,7.12733072 7.42366529,6.66533534 7.699,6.264 C7.97433471,5.86266466 8.35933086,5.55000112 8.854,5.326 C9.34866914,5.10199888 9.91799678,4.99 10.562,4.99 L10.562,3.8 L11.038,3.8 L11.038,5.004 C11.9526712,5.06933366 12.680664,5.33999762 13.222,5.816 C13.763336,6.29200238 14.0759996,6.89399636 14.16,7.622 L12.438,7.622 C12.3819997,7.28599832 12.2350012,6.99433457 11.997,6.747 C11.7589988,6.49966543 11.4393353,6.33866704 11.038,6.264 L11.038,9.344 Z M8.994,7.594 C8.994,8.00466872 9.12933198,8.32899881 9.4,8.567 C9.67066802,8.80500119 10.0579975,9.01266578 10.562,9.19 L10.562,6.222 C10.0766642,6.23133338 9.6940014,6.35499881 9.414,6.593 C9.1339986,6.83100119 8.994,7.16466452 8.994,7.594 Z"
            id="$"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
          <path
            d="M11.038,13.852 L11.038,10.786 C11.5606693,10.9633342 11.9619986,11.1709988 12.242,11.409 C12.5220014,11.6470012 12.662,11.9806645 12.662,12.41 C12.662,12.8300021 12.5196681,13.175332 12.235,13.446 C11.9503319,13.716668 11.5513359,13.852 11.038,13.852 Z"
            id="Path"
            fill="#0088FF"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
